import actionTypes from './constants';

/* */
const initialState = {
  cart: [],
  products: [],
  clientId: null,
};

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE: {
      return {
        ...initialState,
        ...action.payload,
      };
    }
    case actionTypes.UPDATE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.ADD_PRODUCT_TO_CART:
      return {
        ...state,
        cart: [...state.cart, action.payload],
      };
    default:
      return state;
  }
};
